const REFRESH_KEY = 'grossbuch.refresh'
const LEDGER_KEY = 'grossbuch.ledger'

/**
 * Refresh живёт в localStorage, access — только в памяти.
 *
 * Access короткий и переживать перезагрузку не должен; refresh обязан, иначе вход по passkey
 * пришлось бы повторять при каждом открытии приложения — а это ровно то трение, из-за которого
 * ежедневный ввод перестаёт быть ежедневным.
 */
export const refreshStorage = {
  read: () => localStorage.getItem(REFRESH_KEY),
  write: (token: string) => localStorage.setItem(REFRESH_KEY, token),
  clear: () => localStorage.removeItem(REFRESH_KEY),
}

/** Активная книга. В URL её нет: на главном экране она не меняется примерно никогда. */
export const ledgerStorage = {
  read: () => localStorage.getItem(LEDGER_KEY),
  write: (id: string) => localStorage.setItem(LEDGER_KEY, id),
  clear: () => localStorage.removeItem(LEDGER_KEY),
}
